var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.356,
    height: 23.627,
    viewBox: "0 0 21.356 23.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(12906.016 -11184.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_399",
    "data-name": "Path 399",
    transform: "translate(-12890.654 11184.549)",
    fill: "#2197ed",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0H4.995a1,1,0,0,1,1,1V22.626a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000001907348633 0.9999942779541016 L 1.000001907348633 22.62604522705078 L 4.994741916656494 22.62604522705078 L 4.994741916656494 0.9999942779541016 L 1.000001907348633 0.9999942779541016 M 1.000001907348633 -5.7220458984375e-06 L 4.994741916656494 -5.7220458984375e-06 C 5.547031879425049 -5.7220458984375e-06 5.994741916656494 0.4477138519287109 5.994741916656494 0.9999942779541016 L 5.994741916656494 22.62604522705078 C 5.994741916656494 23.17833518981934 5.547031879425049 23.62604522705078 4.994741916656494 23.62604522705078 L 1.000001907348633 23.62604522705078 C 0.4477119445800781 23.62604522705078 1.9073486328125e-06 23.17833518981934 1.9073486328125e-06 22.62604522705078 L 1.9073486328125e-06 0.9999942779541016 C 1.9073486328125e-06 0.4477138519287109 0.4477119445800781 -5.7220458984375e-06 1.000001907348633 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "rgba(33,151,237,0.35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    transform: "translate(-12906.016 11199.049)",
    fill: "#2197ed",
    stroke: "rgba(33,151,237,0.35)",
    strokeWidth: 1,
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.995,
    height: 9.127,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.995,
    height: 8.127,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    transform: "translate(-12898.272 11191.922)",
    fill: "#2197ed",
    stroke: "rgba(33,151,237,0.35)",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.995,
    height: 16.253,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.995,
    height: 15.253,
    rx: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneBar);
export default __webpack_public_path__ + "static/media/oneBar.cae545a1a931e34695058152d1fc4e7a.svg";
export { ForwardRef as ReactComponent };